

// Source : https://www.codevoila.com/post/30/export-json-data-to-downloadable-file-using-javascript
export function exportToJsonFile(jsonData) {
    let dataStr = JSON.stringify(jsonData, null, 2);
    let dataUri = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);

    let exportFileDefaultName = jsonData['meta']['name']+'.cube';

    let linkElement = document.createElement('a');
    linkElement.setAttribute('href', dataUri);
    linkElement.setAttribute('download', exportFileDefaultName);
    linkElement.click();
}